import { PuzzlePiece } from '@phosphor-icons/react';

export default PuzzlePiece;
